import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import './SignUp.css'; // Ensure the CSS file is correctly linked
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import CreateTeam from './CreateTeam'; // Import the CreateTeam component

function SignUp() {
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: ''
    });
    const [message, setMessage] = useState('');
    const [selectedOption, setSelectedOption] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('http://localhost:3001/api/signup', formData);
            setMessage(response.data.message);
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('userId', response.data.userId);
            // Redirect to profile page
            navigate(`/profile/${response.data.userId}`);
        } catch (error) {
            console.error('Error creating account:', error);
            setMessage(error.response ? error.response.data.message : 'Error creating account');
        }
    };

    const handleOptionClick = (option) => {
        setSelectedOption(option);
    };

    return (
        <div className="sign-up-container">
                 <Helmet>
                <title>Sign Up for RCScouting - Create Your Account</title>
                <meta name="description" content="Create your RCScouting account to join our community and connect with Rocket League players and teams. Start your journey today!" />
            </Helmet>
            <h2>Create an Account</h2>
            <div className="sign-up-options">
                <div className={`sign-up-option ${selectedOption === 'add-team' ? 'selected' : ''}`} onClick={() => handleOptionClick('add-team')}>
                    <h3>Add Your Team</h3>
                </div>
                <div className={`sign-up-option ${selectedOption === 'create-team' ? 'selected' : ''}`} onClick={() => handleOptionClick('create-team')}>
                    <h3>Create Your Team</h3>
                </div>
                <div className={`sign-up-option ${selectedOption === 'create-account' ? 'selected' : ''}`} onClick={() => handleOptionClick('create-account')}>
                    <h3>Create RCScouting Account</h3>
                </div>
            </div>
            {selectedOption === 'add-team' && (
                <div>
                    <h3>Add Your Team</h3>
                    {/* Add form or logic for adding a team here */}
                </div>
            )}
            {selectedOption === 'create-team' && (
                <div>
                    <CreateTeam userId={formData.userId} />
                </div>
            )}
            {selectedOption === 'create-account' && (
                <form onSubmit={handleSubmit}>
                    <label>
                        Username:
                        <input
                            type="text"
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            required
                        />
                    </label>
                    <label>
                        Email:
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </label>
                    <label>
                        Password:
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                    </label>
                    <button type="submit">Create RCScouting Account</button>
                </form>
            )}
            {message && <p>{message}</p>}
        </div>
    );
}

export default SignUp;
